import { useCallback } from 'react';

import type { SlotPopupSource } from '@sunflower-games/analytics-events';

import { EnumOpenDialog } from '../../stores/ui/types';
import { useStores } from '../../stores/useStores';

// Winners banner + Daily Missions slot click (MZ-777). Gate: a logged-in player (the logged-out
// landing page mounts no dialogs) and the slot is in one of the lobby's categories. Every such game is
// also in the registry the pop-up renders from.
export function useCanOpenSlotPopup(): (gameId: number) => boolean {
  const { authStore, categoriesStore } = useStores();

  return useCallback(
    (gameId: number) => authStore.authorized && categoriesStore.isGameInAnyCategory(gameId),
    [authStore, categoriesStore],
  );
}

export function useOpenSlotPopup(): (gameId: number, source: SlotPopupSource) => void {
  const { uiStore } = useStores();
  const canOpenSlotPopup = useCanOpenSlotPopup();

  return useCallback(
    (gameId: number, source: SlotPopupSource) => {
      if (!canOpenSlotPopup(gameId)) return;
      uiStore.setOpenDialog({ dialog: EnumOpenDialog.isOpenSlotPopupDialog, options: { gameId, source } });
    },
    [canOpenSlotPopup, uiStore],
  );
}
